import { addNewTooltipToButton } from './modules/tooltips';
var AdivisorOption = function AdivisorOption(options) {
  var getIeBrowserVersion = () => {
    var rv = -1; // Return value assumes failure.
    if (navigator.appName === 'Microsoft Internet Explorer') {
      var ua = navigator.userAgent;
      var re = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})');
      if (re.exec(ua) !== null) {
        rv = parseFloat(RegExp.$1);
      }
    } else if (navigator.appName === 'Netscape') {
      // in IE 11 the navigator.appVersion says 'trident'
      // in Edge the navigator.appVersion does not say trident
      if (navigator.appVersion.indexOf('Trident') === -1) {
        // Not IE, Edge
        rv = 12;
      } else {
        rv = 11;
      }
    }
    return rv;
  };

  // Surface/touch detection
  var isTouchEnabled = false;
  var isTouchDevice = 'ontouchstart' in document.documentElement;
  var maxTouchPoints = navigator.maxTouchPoints || navigator.msMaxTouchPoints;
  if (isTouchDevice || maxTouchPoints > 1) {
    isTouchEnabled = true;
  }
  // Fix for edge on actual non-touch devices
  if (getIeBrowserVersion() > -1 && maxTouchPoints > 2) {
    isTouchEnabled = true;
  } else {
    isTouchEnabled = false;
  }
  // console.log(getIeBrowserVersion() + '/' + isTouchEnabled);

  var $option = options.jqSelector;
  var onClickCallback = options.onClickCallback;
  var containerXPos = 0;
  var addEventHandlers = function() {
    // Check if touch device
    if (getIeBrowserVersion() > -1 && isTouchEnabled) {
      // Don't add events
    } else {
      $option
        .on('mouseenter', function() {
          $option.addClass('is-active');
        })
        .on('mouseleave', function() {
          $option.removeClass('is-active');
        })
    }
    $option.on('mousedown', function() {
      containerXPos = $option.parent().offset().left;
    });
    $option.on('mouseup', function() {
      if (containerXPos !== $option.parent().offset().left) {
        return;
      }
      if (onClickCallback) {
        onClickCallback();
      }
    });
    $option.on('keydown', function(event) {
      if (event.keyCode === 13 && onClickCallback) {
        onClickCallback();
      }
    });
  };
  var init = function() {
    addEventHandlers();
  };
  init();
};

var Advisor = function Advisor() {
  var data,
  matchCutoff = 50, // must be at least a 50% match to be returned
  cls_selected = 'selected',
  cls_active = 'is-active',
  cls_hidden = 'hidden',
  cls_option = 'advisor-step--slide',
  cls_tab = 'filter-tabs--tab',
  cls_recommendation = 'your-recommendation-wrapper',
  cls_step = 'advisor-step',
  cls_stepNav = 'advisor-step-nav',
  cls_stepNavPrev = 'advisor-step-nav-prev',
  cls_stepNavNext = 'advisor-step-nav-next',
  attr_id = 'data-paId',
  slider = $('#advisor-slider'),
  resultWrapperDiv = $('.result-wrapper'),
  currentStep = 1,
  noMatchDefault = '',
  numSteps = $('.advisor-step--wrapper').length,
  nonMatchesHtml = '';

  this.init = function(options) {
    // Set data source
    data = options.data;
    // Main slider containing 4 steps
    slider.slick({
      arrows: false,
      infinite: false,
      swipe: false,
      draggable: false,
      waitForAnimate: false
    });

    // Add click event to step tabs
    /* $('.' + cls_tab).on('click', function() {
      currentStep = $(this).index() + 1;
      gotoStep($(this).index());
    }); */
    $('.' + cls_tab + '> button').on('click', function() {
      currentStep = $(this).parent().index() + 1;
      gotoStep($(this).parent().index());
    });
    $('.' + cls_tab + '> button').on('focus', function() {
      currentStep = $(this).parent().index() + 1;
      gotoStep($(this).parent().index());
    });

    // Add event handlers to step options
    $('.' + cls_option).each(function() {
      var $this = $(this); 
      var option = new AdivisorOption({
        jqSelector: $(this),
        onClickCallback: function() {
          $this.toggleClass(cls_selected);
          // Deselect every other sibling, except if on step 4
          if (currentStep !== numSteps) {
            $this.siblings().removeClass(cls_selected);
          }
          // Update results
          update();
          // If option is no longer selected, remove focus
          if (!$this.hasClass(cls_selected)) {
            document.activeElement.blur();
          }
          // Each selection advances except step 4
          // Do not advance if unselecting
          if (currentStep !== 4 && currentStep !== numSteps && $this.hasClass(cls_selected)) {
            gotoStep(currentStep);
          }
        }
      });
    });

    // Add slick to individual steps for smaller screen sizes
    $('.' + cls_step).each(function() {
      var $this = $(this);
      $this.slick({
        arrows: false,
        centerMode: false,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: $this.find('.' + cls_option).length
            }
          },
          {
            breakpoint: 860,
            settings: {
              slidesToShow: $this.find('.' + cls_option).length
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 4,
            }
          }
        ]
      });   
    });

    // Advisor step nav (smaller screens)
    $('.' + cls_stepNav).on('click', function(event) {
      event.stopPropagation();
      var $this = $(this);
      if ($this.hasClass(cls_stepNavPrev)) {
        gotoStep(currentStep - 2);
      } else if ($this.hasClass(cls_stepNavNext)) {
        gotoStep(currentStep);
      }
    });

    // Check params for option
    // Could do comma separated list if we wanted...
    var urlOpt = getParameterByName('option');
    if (urlOpt !== '') {
      var option = $('.' + cls_option + '[' + attr_id + '="' + urlOpt + '"]');
      currentStep = getCurrentStep(option) + 1;
      if (currentStep >= numSteps) {
        currentStep = 1;
      }
      option.addClass(cls_selected);
    }
    // Inits
    // Go to the next step
    gotoStep(currentStep - 1);
  };

  this.setDefaultRecommendation = function() {
    // Set default recommendation
    setRecommendation();
    updateDOM();
    // Sort by priority/generally
    update();
  };

  function getParameterByName(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  function gotoStep(num) {
    slider.slick('slickGoTo', num);
    currentStep = num + 1;
    setActiveTab();
  }

  function getCurrentStep(option) {
    return option.closest('.advisor-step--wrapper').index() + 1;
  }

  function getRecommendendProductElement() {
    var id = '';
    for (var i = 0; i < data.length; i++) {
      // Get first product that isn't hidden
      if (id === '' && !data[i].isHidden) {
        id = data[i].id
      }
    }
    return $('.matched-result[data-product="' + id + '"] ');
  }

  function addBackTooltipEvents(card) {
    if (!card) {
      return;
    }
    var tooltipBtns = card.querySelectorAll('[data-tooltip-id]');
    for (var i = 0; i < tooltipBtns.length; i++) {
      addNewTooltipToButton({
        btn: tooltipBtns[i],
      });
    }
  }
  function setRecommendation() {
    // Before clearing card, remove hidden from featured card in grid
    // Clear out current contents
    $('.' + cls_recommendation).empty();
    var card = getRecommendendProductElement();
    card.contents().clone().appendTo('.' + cls_recommendation);
    addBackTooltipEvents(document.querySelector('.' + cls_recommendation));
    // Hide card in grid
    card.addClass(cls_hidden);
  }

  function setActiveTab() {
    $('.' + cls_tab + '.' + cls_active).removeClass(cls_active);
    $('.' + cls_tab + ':eq(' + (currentStep - 1) + ')').addClass(cls_active);
  }

  function formatOptionHtml(option) {
    return '<p>' + option + '</p>'
  }

  function update() {
    // Reset DOM
    reset();
    var totalScore = 0;
    // What is the total score for each selected option
    $('.' + cls_option + '.' + cls_selected).each(function() {
      totalScore += parseInt($(this).attr('data-paMaxVal'));
    });
    var p, s;
    for (var i = 0; i < data.length; i++) {
      p = data[i];
      p.score = 0;
      p.matchDetails = '';
      p.noMatchDetails = noMatchDefault;
      p.totalScore = totalScore;
      // If nothing is selected, return all
      if ($('.' + cls_option + '.' + cls_selected).length === 0) {
        p.isHidden = false;
        p.percentageMatch = 1;
        p.percentageMatchDisplay = 'N/A';
      } else {
        // Get all selected options
        $('.' + cls_option + '.' + cls_selected).each(function() {
          p.score += p.values[$(this).attr(attr_id)];
          // If we're checking material, then need to be exclusive
          p.isHidden = !materialMatch(p);
          // Wrap option w/ html formatting 
          s = formatOptionHtml($(this).find('.heading--icon').text());
          if (p.values[$(this).attr(attr_id)] === 0) {
            p.noMatchDetails += s;
          } else {
            p.matchDetails += s;
          }
        });
        // Clear out noMatchDetails if no noMatches exist
        if (p.noMatchDetails === noMatchDefault) {
          p.noMatchDetails = '';
        }
        p.percentageMatch = Math.round((p.score / totalScore) * 10000)/100;
        p.percentageMatchDisplay = String(Math.round((p.score / totalScore) * 10000)/100) + '%';

        if (p.score === 0) {
          p.isHidden = true;
        }
      }
    }
    // Multi-dimension sort, by score and isHidden
    data.sort(sort);
    // Below 50% match, cut it off
    var isMatch,
    isHighest = -1,
    median = matchCutoff;
    for (i = 0; i < data.length; i++) {
      p = data[i];
      if (!p.isHidden && p.percentageMatch > isHighest) {
        isHighest = p.percentageMatch;
        if (isHighest < median) {
          median = isHighest;
        }
      }
      // console.log('median: ' + median + '        best match %: ' + isHighest + '%');
      if (p.percentageMatch < median) {
        p.isHidden = true;
      }
    }

    // Update DOM
    var logStr = '-------\nMatches\n-------\n';
    var len = 0,
      item;
    for (i = 0; i < data.length; i++) {
      p = data[i];
      item = $('.matched-result[data-product="' + p.id + '"]');
      if (!p.isHidden) {
        logStr += p.name + ': ' + p.percentageMatch + '%\n';
        item.removeClass(cls_hidden);
        // Add match/no-match to tooltips
        item.find('.match .tooltip-inner').empty().append(p.matchDetails);
        item.find('.no-match .tooltip-inner').empty().append(p.noMatchDetails);
        len++;
      } else {
        item.addClass(cls_hidden);
      }
      // Add match/no-match count to tooltip buttons
      var matchCt = item.find('.match .tooltip-inner').children('p').length;
      var noMatchCt = item.find('.no-match .tooltip-inner').children('p').length;
      var matchCtDisplay = '0';
      var noMatchCtDisplay = '0';
      if (matchCt > 0) {
        matchCtDisplay = '+' + matchCt;
        item.find('.card-features .match button').removeAttr('disabled');
      } else {
        item.find('.card-features .match button').attr('disabled', 'disabled');
      }
      if (noMatchCt > 0) {
        noMatchCtDisplay = '+' + noMatchCt;
        item.find('.card-features .no-match button').removeAttr('disabled');
      } else {
        item.find('.card-features .no-match button').attr('disabled', 'disabled');
      }
      item.find('.card-features .match button var').text(matchCtDisplay);
      item.find('.card-features .no-match button var').text(noMatchCtDisplay);
    }
    // If there's no matches
    if (len === 0) {
      logStr += 'No matches.\n'; 
    }
    setRecommendation();
    updateDOM();
    // console.log(logStr);
  }

  function updateDOM() {
    // Resort based on what's not hidden, remove the hiddens
    var p, item;
    for (var i = 0; i < data.length; i++) {
      p = data[i];
      item = $('.matched-result[data-product="' + p.id + '"]');
      if (item.hasClass(cls_hidden)) {
        nonMatchesHtml += item[0].outerHTML;
        item.detach();
      } else {
        resultWrapperDiv.append(item);
        addBackTooltipEvents(document.querySelector('.matched-result[data-product="' + p.id + '"]'));
      }
    }
    // If there are no results in "Also consider..." then hide that div
    // Also vice versa
    if ($('#alsoConsiderContent .matched-result').length === 0) {
      $('#alsoConsiderContent').addClass(cls_hidden);
    } else {
      $('#alsoConsiderContent').removeClass(cls_hidden);
    }   
  }

  function reset() {
    // Readd non-matches to DOM
    resultWrapperDiv.append(nonMatchesHtml);
    // Reset nonMatchesHtml
    nonMatchesHtml = '';
  }

  function sort(a,b) {
    if (a.percentageMatch < b.percentageMatch)
      return 1;
    if (a.percentageMatch > b.percentageMatch)
      return -1;
    if (a.percentageMatch === b.percentageMatch)
      // Should look at priority here
      if (a.values.Priority !== 0 || b.values.Priority !== 0) {
        return sortPriority(a,b);
      } else {
        return sortAbc(a,b);
      }
  }

  function sortAbc(a,b) {
    if (a.name < b.name)
      return -1;
    if (a.name > b.name)
      return 1;
    return 0;
  }

  function sortPriority(a,b) {
    if (a.values.Priority < b.values.Priority)
      return 1;
    if (a.values.Priority > b.values.Priority)
      return -1;
    return 0;
  }

  function materialMatch(prod) {
    // if there are none selected, do not use as criteria and return all
    if ($('.' + cls_step + ':eq(2) .' + cls_selected).length === 0) {
      return true;
    }
    // Otherwise check
    var match = false;
    $('.' + cls_step +':eq(2) .' + cls_selected).each(function() {
      if (prod.values[$(this).attr(attr_id)] === 1) {
        match = true;
      }
    });
    // See if match, return true/false
    return match;
  }

  return this;
}
// Instantiate...
window.advisor = new Advisor();
